<template>
    <div >
        <div class="row">
            <div class="col"><breadcrumb :links="crumbNav"></breadcrumb></div>
        </div>
        <div class="row" v-if="!pageLoading">
            <div class="col">
                <div class="row">
                    <div class="col-12 col-lg">
                        <span class="paragraph paragraph--heading">Your selected vehicle</span>
                        <heading
                                :text="vehicleModel"
                                :sub="vehicleName">
                        </heading>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <vehicle-image :source="vehicleImage" :vehicle="vehicle"></vehicle-image>
                    </div>
                </div>
                <div class="row description">
                    <div class="col">
                        <span class="description__text">P11D: {{p11d | toCurrency}}</span>
                        <span class="description__text">Initial rental payments: {{initial}}</span>
                        <span class="description__text">Contract length:  {{term}}</span>
                        <span class="description__text">Annual mileage: {{mileage | numberFormat}}</span>
                        <span class="description__text">Maintenance: {{maintenance}}</span>
                        <span class="description__text description__text--highlight">From {{financeCostCalculated | toCurrency}} per month excl VAT</span>
                    </div>
                </div>
                <div class="row disclaimer-block">
                    <div class="col">
                        <disclaimer :cms-text="disclaimer"></disclaimer>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg">
                <heading :text="'Vehicle enquiry form'"></heading>
                <p class="paragraph">{{formParagraph}}</p>
                <iframe :src="iframe + iframeVehicle" id="enquire-iframe" style="width: 1px; min-width: 100%; border: 0px none; overflow: hidden;" scrolling="no" type="text/html" allowtransparency="true" frameborder="0" v-resize></iframe>
            </div>
        </div>
        <loader v-else></loader>
    </div>

</template>

<script>
    import Heading from "../components/Heading";
    import VehicleImage from "../components/VehicleDetails/VehicleImage";
    import Disclaimer from "../components/Disclaimer";
    import {GET_DISCLAIMER} from "../store/action-types";
    import Loader from "../components/Loader";
    import Breadcrumb from "../components/Breadcrumb";

    export default {
        name: "Enquire",

        metaInfo () {
            return {
                title: 'Small business offers - Enquire',
                meta: [
                    { vmid: 'description', name: 'description', content: 'Enquire about Volkswagen Group vehicles small business leasing options.' }
                ]
            }
        },

        components: {Breadcrumb, Loader, Disclaimer, VehicleImage, Heading},

        data: function() {
            return {
                formParagraph: 'Please complete the below enquiry form, including any questions you may have and we\'ll be in touch shortly. Please complete all fields marked with *.',
                iframe: "https://www2.vwfsfleet.co.uk/l/151741/2019-09-05/mzpnzn",
                disclaimerId: 1,
                pageLoading: true,
                staticServicePart: 3.44
            }
        },
        methods: {
            getDisclaimer: function () {
                this.$store.dispatch(GET_DISCLAIMER, this.disclaimerId);
                this.pageLoading=false
            },
            capitalize: function (value) {
                if (typeof value !== 'string') return value;
                return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
            }
        },
        computed: {
            vehicle: function () {
                return this.$store.state.VEHICLE;
            },
            disclaimer: function () {
                return this.$store.state.CMS_DISCLAIMER;
            },
            vehicleModel: function () {
                return this.vehicle.model.range.make.name + ' ' + this.vehicle.model.name.replace(/(PETROL|DIESEL)/gi, '');
            },
            vehicleName: function () {
                return this.vehicle.name + ' MY' + Math.floor(this.vehicle.model.range.year.year);
                // return this.vehicle.model.body.name + ' ' + this.vehicle.name + ' MY' + Math.floor(this.vehicle.model.range.year.year);
            },
            vehicleImage: function () {
                return (this.vehicle.model.range.mainImage) ? this.vehicle.model.range.mainImage : ''
            },
            p11d: function() {
                return this.vehicle.meta.p11d;
            },
            initial: function() {
                return this.$store.state.FINANCE_FILTER_ADVANCE;
            },
            term: function() {
                return this.$store.state.FINANCE_FILTER_TERM;
            },
            mileage: function() {
                return this.$store.state.FINANCE_FILTER_MILEAGE;
            },
            maintenance: function () {
                return (this.$store.state.FINANCE_FILTER_MAINT) ? 'Yes' : 'No';
            },
            selectedFinance: function () {
                return this.$store.getters.selectedOffer;
            },
            financeCost: function () {
                if (this.selectedFinance) {
                    return this.selectedFinance.finance;
                }
                return null;
            },
            financeCostCalculated: function () {
                if (this.selectedFinance) {
                    return (this.$store.state.FINANCE_FILTER_MAINT) ? (this.selectedFinance.finance + this.maintCost) : (this.selectedFinance.finance + this.staticServicePart);
                }
                return null;
            },
            maintCost: function () {
                if (this.selectedFinance) {
                    return (this.maintenance) ? this.selectedFinance.service : 0;
                }
                return null;
            },
            slug: function() {
                if (this.selectedFinance) {
                    return this.selectedFinance.slug;
                }
                return 'n-a';
            },
            crumbNav: function() {
                return [
                    {name: 'home', text: 'Small business offers home'},
                    {name: 'details', text: 'Vehicle Details', params: {slug: this.slug}}
                ]
            },
            iframeVehicle: function() {
                let query = '?SME_Selected_Vehicle=' + this.slug + this.financeSlug;

                if (this.$store.state.PRESET_MANUFACTURER) {
                    let vm = this;
                    let man = this.$store.state.MANUFACTURER_LIST.find(function(el){
                        return el.id === vm.$store.state.FILTER_MANUFACTURER;
                    });
                    query = query + '&SME_Selected_Brand=' + man.name;
                }

                return query;
            },
            financeSlug: function() {
                return '-term:' + this.term + '-initial:' + this.initial + '-mileage:' + this.mileage + '-maint:' + this.maintenance + '-price:' + this.financeCostCalculated
            }
        },
        created: function () {
            this.pageLoading = true;
            this.getDisclaimer();
            this.$tracking.logPageLoad('SME-Price-List:Enquire');
        },
        mounted() {
            this.$scrollTo('.crumb-nav');
        }
    }
</script>

<style scoped lang="stylus">
.paragraph
    &--heading
        margin 45px auto 5px
        display block
.description
    margin-top 0
    margin-bottom 2rem
    &__text
        display block
        font-size 18px
        line-height 28px
        font-family: "VWAGTheSansRegular", Arial, sans-serif;
        &--highlight
            font-family: "VWAGTheSansBold", Arial, sans-serif;
            color #004666
>>>
    .heading h2
        margin 0
    .image-wrap
        padding-top 0
</style>